import type {
  CssBaseAnimationVariables,
  FlipVariants,
  LiteralSizes,
  Units,
} from '../public/types';

export const BASE_SIZE_PROP = '--base-size';
export const ICON_BASE_SIZES: LiteralSizes[] = ['sm', 'md', 'lg', 'xl'];
export const UNIT_SIZES: Units[] = [
  '%',
  'ch',
  'em',
  'px',
  'rem',
  'vh',
  'vw',
  'vmax',
  'vmin',
];
export const BASE_SIZE = '1em';
export const DEFAULT_ANIMATION_UNIT = 'ms';
export const FLIP_CORRESPONDENCE: Record<FlipVariants, string> = {
  both: 'flip-both',
  horizontal: 'flip-horizontal',
  vertical: 'flip-vertical',
  none: '',
};

export const ANIMATION_PROPS: CssBaseAnimationVariables[] = [
  'duration',
  'direction',
  'delay',
  'iterate',
];

export const ANIMATION_DEFAULTS: Record<CssBaseAnimationVariables, string> = {
  duration: '300ms',
  direction: 'normal',
  delay: '0ms',
  iterate: '1',
};
